import { useState, useEffect } from "react"
import { apiJSONURL } from "../../../App"
import { useGlobalContext } from "../../data/GlobalContext"
export default function ShareCreditsRequest() {
  const { username, playerDetails } = useGlobalContext()
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState("")
  const [isTransferTo, setTransferTo] = useState("")
  const [isAmount, setAmount] = useState("")
  const [enteredPin, setEnteredPin] = useState("")
  const isLoggedIn = Boolean(username)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!isLoggedIn) return

    setMessage("Processing...")
    setLoading(true)

    if (enteredPin.trim() !== playerDetails.pin) {
      setMessage("Incorrect PIN. Please try again.")
      setLoading(false)
      return
    }

    const formData = new URLSearchParams()
    formData.append("cmd", "createMemberTransfer")
    formData.append("fromLogin", username)
    formData.append("toLogin", isTransferTo)
    formData.append("amount", isAmount)

    try {
      const response = await fetch(apiJSONURL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      })

      const data = await response.json()
      if (data.s) {
        setMessage(
          `We have received your request ${data.s}. Please kindly wait for us to process.`
        )
        setAmount("")
        setEnteredPin("")
        setTransferTo("")
      } else {
        setMessage(data.e || "An error occurred.")
        setAmount("")
        setEnteredPin("")
        setTransferTo("")
      }
    } catch (error) {
      console.error("Error submitting form:", error)
      setMessage("An error occurred, please try again.")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("")
      }, 30000)

      return () => clearTimeout(timer)
    }
  }, [message])

  return (
    <>
      <div className="share-credits-container">
        <div className="share-credits-form">
          <form onSubmit={handleSubmit}>
            <div className="password-field">
              <input
                placeholder="Current Password"
                autoComplete="off"
                name="fromLogin"
                value={username}
                readOnly
                disabled
              />
            </div>
            <div className="password-field">
              <input
                placeholder="Transfer To"
                name="toLogin"
                autoComplete="off"
                value={isTransferTo}
                onChange={(e) => setTransferTo(e.target.value)}
              />
            </div>
            <div className="password-field">
              <input
                placeholder="Amount"
                name="amount"
                inputMode="numeric"
                value={isAmount}
                autoComplete="off"
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
            <div className="password-field">
              <input
                placeholder="Your 4 digit PIN"
                name="pin"
                type="password"
                inputMode="numeric"
                autoComplete="off"
                value={enteredPin}
                maxLength={4}
                onChange={(e) => setEnteredPin(e.target.value)}
              />
            </div>

            {message && <div className="change-password-msg">{message}</div>}

            <div className="share-credit-container">
              <button
                type="submit"
                className={`share-credit-btn ${
                  isTransferTo.trim() === "" ||
                  isAmount.trim() === "" ||
                  enteredPin.trim() === ""
                    ? "disabled"
                    : ""
                }`}
                disabled={
                  isTransferTo.trim() === "" ||
                  isAmount.trim() === "" ||
                  enteredPin.trim().length == "" ||
                  loading
                }
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
        <h3>What is Share Credits Request?</h3>
        <p>
          Share Credits Request is a new feature which allow you to transfer
          your balance to another account registered in FGH.
        </p>
        <h3>What is Share Credits</h3>
        <ol>
          <li>
            Enter the username of the person you're transferring to in the
            [Transfer To] field, type in the amount you want to send, then click
            SUBMIT.
          </li>
          <li>
            Let our customer support team know about your Share Credits request.
            Once it's approved, the recipient will have to click [Accept] under
            the [Share Credits Report] found in the Accounts section.
          </li>
          <li>
            Once the user accepted, they will receive the amount directly to
            their balance.
          </li>
        </ol>
        <h3>Terms and Conditions</h3>
        <ul>
          <li>
            You need to clear all your rollover requirement before applying for
            [Share Credits Request]
          </li>
          <li>
            The receiver will need to complete a 1x rollover requirement of the
            amount they receive before withdrawal.
          </li>
          <li>We reserve the right to change the T&C without prior notice.</li>
        </ul>
      </div>
    </>
  )
}
